module.exports = __webpack_public_path__ + "eisoftware.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eisoftware.png
// module id = 1544
// module chunks = 0